(() => {
  if (window.MinimogProductInfoUpsellLoaded) return;
  window.MinimogProductInfoUpsellLoaded = true;

  const selectors = {
    item: '[data-minimog-upsell-item]',
    form: '[data-minimog-upsell-form]',
    option: '[data-minimog-upsell-option]',
    variants: '[data-minimog-upsell-variants]',
    variantInput: '[data-minimog-upsell-variant-id]',
    submit: '[data-minimog-upsell-submit]',
    buttonText: '[data-minimog-upsell-button-text]',
    priceCurrent: '[data-minimog-upsell-price-current]',
    priceCompare: '[data-minimog-upsell-price-compare]',
    image: '[data-minimog-upsell-image]'
  };

  const getVariants = (item) => {
    if (item._minimogUpsellVariants) return item._minimogUpsellVariants;
    const script = item.querySelector(selectors.variants);
    if (!script) return [];
    try {
      item._minimogUpsellVariants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.error('Minimog product info upsell variants JSON error:', error);
      item._minimogUpsellVariants = [];
    }
    return item._minimogUpsellVariants;
  };

  const getSelectedOptions = (item) => {
    const selects = Array.from(item.querySelectorAll(selectors.option));
    if (!selects.length) return [];
    return selects
      .sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0))
      .map((select) => select.value);
  };

  const findSelectedVariant = (item) => {
    const variants = getVariants(item);
    const selectedOptions = getSelectedOptions(item);
    if (!selectedOptions.length) return variants[0];

    return variants.find((variant) => {
      return selectedOptions.every((value, index) => variant[`option${index + 1}`] === value);
    });
  };

  const updateItem = (item) => {
    const variant = findSelectedVariant(item);
    const input = item.querySelector(selectors.variantInput);
    const submit = item.querySelector(selectors.submit);
    const buttonText = item.querySelector(selectors.buttonText);
    const priceCurrent = item.querySelector(selectors.priceCurrent);
    const priceCompare = item.querySelector(selectors.priceCompare);
    const image = item.querySelector(selectors.image);

    const addLabel = item.dataset.addLabel || 'Add';
    const soldOutLabel = item.dataset.soldOutLabel || 'Sold out';
    const unavailableLabel = item.dataset.unavailableLabel || 'Unavailable';

    if (!variant) {
      if (input) input.value = '';
      if (submit) submit.disabled = true;
      if (buttonText) buttonText.textContent = unavailableLabel;
      item.classList.add('is-sold-out');
      return;
    }

    if (input) input.value = variant.id;
    if (priceCurrent && variant.price_formatted) priceCurrent.textContent = variant.price_formatted;

    if (priceCompare) {
      const showCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      priceCompare.classList.toggle('m:hidden', !showCompare);
      if (showCompare && variant.compare_at_price_formatted) {
        priceCompare.textContent = variant.compare_at_price_formatted;
      }
    }

    if (image && variant.featured_image) {
      image.src = variant.featured_image;
    }

    const available = Boolean(variant.available);
    if (submit) submit.disabled = !available;
    if (buttonText) buttonText.textContent = available ? addLabel : soldOutLabel;
    item.classList.toggle('is-sold-out', !available);
  };

  const showMessage = (item, type, message) => {
    if (window.MinimogTheme?.Notification?.show) {
      window.MinimogTheme.Notification.show({
        target: item.querySelector('[data-minimog-upsell-message]') || document.body,
        method: 'appendChild',
        type,
        message,
        last: 3000,
        sticky: false
      });
    } else if (message) {
      window.alert(message);
    }
  };

  const addToCart = async (form) => {
    const item = form.closest(selectors.item);
    if (!item) return;

    updateItem(item);

    const variantInput = form.querySelector(selectors.variantInput);
    if (!variantInput || !variantInput.value) {
      showMessage(item, 'error', window.MinimogStrings?.selectVariant || 'Please select a variant.');
      return;
    }

    item.classList.add('is-loading');

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const formData = new FormData(form);
      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);

      const url = window.MinimogSettings?.routes?.cart_add_url || form.getAttribute('action') || '/cart/add';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      });
      const parsed = await response.json();

      if (parsed.status) {
        showMessage(item, 'error', parsed.message || parsed.description || 'Cannot add this item to cart.');
        window.MinimogEvents?.emit?.(window.MinimogTheme?.pubSubEvents?.cartError, {
          source: 'product-info-upsell',
          productVariantId: formData.get('id'),
          errors: parsed.error || parsed.description,
          message: parsed.message
        });
        return;
      }

      if (window.MinimogSettings?.use_ajax_atc !== false) {
        const cartDrawer = document.querySelector('m-cart-drawer');

        if (cartDrawer && window.MinimogSettings?.enable_cart_drawer) {
          if (window.MinimogTheme?.Notification?.show) {
            window.MinimogTheme.Notification.show({
              target: cartDrawer.querySelector('m-cart-items') || cartDrawer,
              method: 'prepend',
              type: 'success',
              message: window.MinimogStrings?.itemAdded || 'Item added to your cart',
              delay: 400
            });
          }
          cartDrawer.open();
        } else {
          showMessage(item, 'success', window.MinimogStrings?.itemAdded || 'Item added to your cart');
        }

        window.MinimogEvents?.emit?.(window.MinimogTheme?.pubSubEvents?.cartUpdate, {
          cart: parsed,
          productVariantId: formData.get('id')
        });

        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
      } else {
        window.location.href = window.MinimogSettings?.routes?.cart || '/cart';
      }
    } catch (error) {
      console.error('Minimog product info upsell add error:', error);
      showMessage(item, 'error', 'Cannot add this item to cart. Please try again.');
    } finally {
      item.classList.remove('is-loading');
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target.matches(selectors.option)) return;
    const item = target.closest(selectors.item);
    if (item) updateItem(item);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches(selectors.form)) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('mouseover', (event) => {
    const item = event.target.closest?.(selectors.item);
    if (item) item.classList.add('is-selected');
  });

  document.addEventListener('mouseout', (event) => {
    const item = event.target.closest?.(selectors.item);
    if (item) item.classList.remove('is-selected');
  });
})();
